import { STATUS_LABELS, type OrderStatus } from '@/features/orders/api'
import { cn } from '@/lib/cn'

/**
 * Colour carries meaning here, so the label always says it too. "Awaiting approval" and
 * "Cancelled" must be distinguishable by someone who cannot tell amber from red.
 */
const TONES: Record<OrderStatus, string> = {
  draft: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  submitted: 'bg-warning/10 text-warning',
  approved: 'bg-brand-500/10 text-brand-600 dark:text-brand-400',
  fulfilled: 'bg-success/10 text-success',
  invoiced: 'bg-success/10 text-success',
  completed: 'bg-success/10 text-success',
  cancelled: 'bg-danger/10 text-danger',
}

export function StatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span
      className={cn('rounded px-2 py-0.5 text-xs font-medium whitespace-nowrap', TONES[status])}
    >
      {STATUS_LABELS[status]}
    </span>
  )
}
